import { IconButton, IconButtonProps } from "@chakra-ui/react";
import React from "react";

export const InputElementButton: React.FC<IconButtonProps> = (props) => (
  <IconButton
    tabIndex={-1}
    variant="ghost"
    width="38px"
    height="38px"
    right="1px"
    onMouseDown={(event) => {
      // Prevents the input from losing focus when clicking the clear button
      event.preventDefault();
    }}
    {...props}
  />
);
